let settings = {
    TicketStatuses: [
        { name: 'All', value: 100 },
        { name: 'Winner', value: 1 },
        { name: 'Lost', value: 0 },
        { name: 'Pending', value: 2 },
        { name: 'Draw', value: -1 },
        { name: 'Cancelled', value: 5 },
        { name: 'Paid', value: 3 },
        { name: 'Expired', value: 4 },
    ],
    VouchersStatuses: [
        { name: 'All', value: 100 },
        { name: 'Pending', value: 2 },
        { name: 'Paid', value: 3 },
    ],
    ticketType: {
        keno: 'KN',
        ballSix: 'BS',
        sportBets: 'SB',
        roulette: 'RL',
        cashOutVoucher: 'CH',
        lotto: 'LT',
        rocket: 'RA',
        wheel: 'TS',
    },
    gameType: {
        keno: 'https://tbet.oddin-platform.com/virtualsweb/keno',
        ballsix: 'https://tbet.oddin-platform.com/virtualsweb/ballsix',
        magnumsix: 'http://92.55.149.74/BilaMagica/bilamagica2.html',
        devicename: 'http://devicename.logicore.ro/devices.html?name=',
        lotto: 'http://tbet-lotto.logicore.ro/',
    },
    currency: ' ',
    countryLocale: 'ro-Ro',
    paymentsProviders: ['All', 'ORANGE'],
    paymentsType: ['CREDIT', 'DEBIT', 'All'],
    paymentsStatuses: ['All', 'SUCCESS', 'FAILED', 'PENDING'],
    paymentsConfirmedStatuses: ['All', 'SUCCESS', 'FAILED'],
    useCNPValidation: true,
    productChannels: {
        all: 'ALL',
        retail: 'RETAIL',
        terminal: 'TERMINAL',
    },
    instalattionTypes: {
        all: 'ALL',
        cashier: 'CASHIER',
        terminal: 'SSBT',
    },
    products: {
        sportsBetting: 'SPORTSBETTING',
        keno: 'KENO',
        ballsix: 'BALLSIX',
        nsoft: 'NSOFT',
        terminal: 'TERMINAL',
        shopCD: 'SHOPCD',
        all: 'ALL',
        lotto: 'LOTTO',
        roulette: 'ROULETTE',
        rocket: 'ROCKET',
        live: 'LIVE',
        wheel: 'WHEEL',
    },
    thirdParties: {
        nsoft: 'NSOFT',
    },
    reportsStartYear: 2019,
    blockedProductsList: [
        { name: 'PS', isBlocked: false },
        { name: 'Keno', isBlocked: false },
        { name: 'BSix', isBlocked: false },
        { name: 'Rlt', isBlocked: false },
        { name: 'Lt', isBlocked: false },
        { name: 'Rocket', isBlocked: false },
        { name: 'Wheel', isBlocked: false },
    ],
};

export default settings;
